import {
  ApplicationConfig,
  importProvidersFrom,
  ErrorHandler,
  CSP_NONCE,
  provideAppInitializer,
  inject
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { routes } from './app.routes';
import { HttpBackend, HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { errorInterceptor } from './shared/interceptors/error.interceptor';
import { headerImplInterceptor } from './shared/interceptors/header-impl.interceptor';
import { provideToastr } from 'ngx-toastr';
import { CustomErrorHandler } from './shared/handlers/custom-error-handler';

import { provideUserIdleConfig } from 'angular-user-idle';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthService } from './shared/service/auth.service';
export const appConfig: ApplicationConfig = {
  providers: [
    { provide: CSP_NONCE, useValue: 'kE3pX8zV9aL7fJ5hR2qY4cT6wB1dG0n' },
    { provide: ErrorHandler, useClass: CustomErrorHandler },
    provideAppInitializer(() => {
  const authService = inject(AuthService);
  return authService.initializeTokenRefresh();
}),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideUserIdleConfig({ idle: 28800, timeout: 40, ping: 10 }),
    BnNgIdleService,
    provideHttpClient(
      withInterceptors([
        errorInterceptor,
        headerImplInterceptor,
      ]),
    ),

    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: (httpBackend: HttpBackend): TranslateHttpLoader =>
            new TranslateHttpLoader(new HttpClient(httpBackend), './assets/languages/', '.json'),
          deps: [HttpBackend],
        },
      }),
      LoggerModule.forRoot({
        level: NgxLoggerLevel.DEBUG,
        serverLogLevel: NgxLoggerLevel.ERROR,
      }),
      NgxSpinnerModule,
    ),
    provideToastr({
      timeOut: 2000,
      positionClass: 'toast-bottom-right',
      preventDuplicates:false,
      maxOpened: 1,
      autoDismiss: true,
      newestOnTop: false,
      closeButton: false,
      progressBar: false,
      tapToDismiss: true,
      enableHtml: false,
      onActivateTick: true, 
      easeTime: 0, 
      easing: 'ease-in', 
      includeTitleDuplicates: true,
    }),
  ],
};


